import React from 'react';
import { SelectionGroup, SelectionGroupItem } from 'fronton-react';
import { SelectionGroupValue } from 'fronton-react/selection-group/types';
import { getVariantText } from 'pages/calculation/helpers/get-variant-text';
import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { VariantsSelectionGroup } from './styles';

type TProps = {
  variants: TComplimentaryProductInfo[];
  selectedValue: string | undefined;
  onChange: (variantProductId: string) => void;
};

export const SelectionGroupView = ({ onChange, selectedValue, variants }: TProps) => {
  const handleChange = (_: React.MouseEvent<Element, MouseEvent>, variantProductId: SelectionGroupValue) => {
    onChange(variantProductId as string);
  };

  return (
    <SelectionGroup
      className={VariantsSelectionGroup}
      active={selectedValue as SelectionGroupValue}
      onChange={handleChange}
      size="m"
      variant="outline">
      {variants.map(variant => {
        const text = getVariantText(variant);

        return (
          <SelectionGroupItem value={variant.productId} key={variant.productId}>
            {text}
          </SelectionGroupItem>
        );
      })}
    </SelectionGroup>
  );
};
